export default __webpack_public_path__ + "static/media/CtA-IAE.07ae55c2.png";